<template>
    <div>
        <div v-if="hasAnyField">
            <div>{{address.name}}</div>
            <div>{{address.companyName}}</div>
            <div>{{address.email}}</div>
            <div>{{address.addressLine1}}</div>
            <div>{{address.addressLine2}}</div>
            <div>
                <span v-if="address.city">{{address.city}}, </span>
                <span v-if="address.state">{{address.state}}, </span>
                <span v-if="address.postal">{{address.postal}}</span>
            </div>
            <div>{{address.country}}</div>
            <div>{{address.phone}}</div>
        </div>
        <div v-else-if="showNoAddressInfo">
            No Address Provided
        </div>
    </div>
</template>

<script>
export default {
    name : "AddressView",
    props : {
        address : {
            type : Object,
            default : null,
            required : false,
        },
        showNoAddressInfo : {
            type : Boolean,
            default : true,
            required : false,
        }
    },
    computed : {
        hasAnyField() {
            return this.address !== null && Object.values(this.address).some(value => value != null && value !== '')
        },
    }
}
</script>
